import * as React from 'react';
import s from './collection-header.scss';
import { Box, Heading } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
import { BackButton } from '../../back-button';
export var dtoToCollectionHeaderProps = function (res) {
    var _a, _b, _c, _d, _e, _f;
    var name = (_b = (_a = res === null || res === void 0 ? void 0 : res.tagsAndSubCategories[0]) === null || _a === void 0 ? void 0 : _a.tag) === null || _b === void 0 ? void 0 : _b.name;
    var teaser = (_f = (_e = (_d = (_c = res === null || res === void 0 ? void 0 : res.tagsAndSubCategories[0]) === null || _c === void 0 ? void 0 : _c.tag) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.collectionDate) === null || _f === void 0 ? void 0 : _f.teaser;
    return {
        name: name,
        teaser: teaser,
    };
};
export var CollectionHeader = composer()
    .withExperiments()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var name = _a.name, teaser = _a.teaser, marketplaceStore = _a.marketplaceStore;
    var shouldShowBackButton = (marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.prevRoute) &&
        marketplaceStore.route.referral !== 'menu_navigation' &&
        marketplaceStore.route.referral !== 'back_button';
    return (React.createElement(Box, { marginBottom: '6px', direction: 'vertical', dataHook: 'collection-header', marginTop: '24px' },
        shouldShowBackButton && React.createElement(BackButton, { skinColor: 'dark' }),
        React.createElement(Heading, { appearance: 'H1', light: false, "data-hook": 'collection-header-text', className: s.collectionTitle },
            React.createElement("span", { className: s.collectionName, "data-testid": 'collection-header-name', "data-hook": 'collection-header-name' }, name),
            React.createElement("span", { "data-testid": 'collection-header-teaser', className: s.collectionTeaser }, teaser))));
});
//# sourceMappingURL=collection-header.js.map